import Category from '@/models/Category';
import { Family } from '@/models/Family';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
    // mainImage: Yup.string().required(), // capa
    type: Yup.string()
        .required()
        .min(1),
    path: Yup.string().required(), // video
    name: Yup.string()
        .required()
        .min(1),
});

export const formInitialState = {
    type: { method: '', type: '' },
    name: '',
    path: '',
    author: '',
    workload: undefined,
    category: { name: '', id: undefined } as Category,
    category2: { name: '', id: undefined } as Category,
    tags: [],
    families: [] as Family[],
};

export const formErrors = {
    typeError: false,
    nameError: false,
    pathError: false,
    categoryError: false,
    category2Error: false,
    tagsError: false,
    workloadError: false,
    authorError: false,
};
